<div>
	<div class="row">
		<div class="col-lg-6 d-flex">
			<span data-testid="SUBSYS2_RECEIVEDLIST_RESULTS_TXT" class="results">
				{{ collectionSize }} {{ labels().RECEIVED_TABLE_COMPONENT_RESULTS }}
			</span>
		</div>
	</div>
</div>

<div class="panel panel-cell panel-thead">

	<div class="row no-gutters">

		<div data-testid="SUBSYS2_RECEIVEDLIST_HEADER_USERNAME" class="col"
			[class.active]="activeColumn === fields.originalUserName">
			<sortable-header [name]="fields.originalUserName" (sort)="onSort($event)">
				{{ labels().RECEIVED_TABLE_COMPONENT_ORIGINAL_USERNAME }}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_RECEIVEDLIST_HEADER_PLANID" class="col"
			[class.active]="activeColumn === fields.planNumber">
			<sortable-header [name]="fields.planNumber" (sort)="onSort($event)">
				{{ labels().RECEIVED_TABLE_COMPONENT_PLAN_ID }}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_RECEIVEDLIST_HEADER_UPDATEDATE" class="col"
			[class.active]="activeColumn === fields.planModifiedDate">
			<sortable-header [name]="fields.planModifiedDate" (sort)="onSort($event)">
				{{ labels().RECEIVED_TABLE_COMPONENT_PLAN_CREATION_DATE }}
			</sortable-header>
			<br>
			<span data-testid="SUBSYS2_RECEIVEDLIST_HEADER_FORMATDATE_TXT" class="date-format">{{ dateFormat }}</span>
		</div>
		<div data-testid="SUBSYS2_RECEIVEDLIST_HEADER_ACTIONS" class="col no-link">
			{{ labels().RECEIVED_TABLE_COMPONENT_ACTIONS }}
		</div>

	</div>

</div>

@for (plan of receivedList; track plan.planId) {
<div class="panel panel-cell panel-tr">

	<div class="row no-gutters">

		<div data-testid="SUBSYS2_RECEIVEDLIST_CELL_USERNAME" class="col">
			{{ plan.originalUserName }}
		</div>
		<div data-testid="SUBSYS2_RECEIVEDLIST_CELL_PLANID" class="col">
			{{ plan.planNumber! | replaceLongLeg }}
		</div>
		<div data-testid="SUBSYS2_RECEIVEDLIST_CELL_UPDATEDATE" class="col">
			{{ plan.caseModifiedDate! | convertDate:false }}
		</div>
		<div data-testid="SUBSYS2_RECEIVEDLIST_CELL_ACTIONS" class="col">
			<received-action [item]="plan" />
		</div>

	</div>

</div>
}

<pagination />